"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalPropTypes = exports.modalDefaultProps = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _hamburger = require("../shapes/hamburger");

var _colors = require("../colors");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Modal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Modal, _React$Component);

  function Modal() {
    (0, _classCallCheck2["default"])(this, Modal);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Modal).apply(this, arguments));
  }

  (0, _createClass2["default"])(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          closeButton = _this$props.closeButton,
          footer = _this$props.footer,
          bsSize = _this$props.bsSize,
          onRequestHide = _this$props.onRequestHide,
          closeOnOutsideClick = _this$props.closeOnOutsideClick,
          style = _this$props.style,
          className = _this$props.className,
          bsStyle = _this$props.bsStyle,
          wrapperStyle = _this$props.wrapperStyle;
      var modalClassName = 'modal-dialog';

      if (bsSize) {
        modalClassName += " modal-".concat(bsSize);
      }

      if (className) {
        modalClassName += ' ' + className;
      }

      var modalBodyClassName = 'modal-content';

      if (bsStyle) {
        modalBodyClassName += " modal-".concat(bsStyle);
      }

      var ModalHeader = _react["default"].createElement("div", {
        className: "modal-header"
      }, _react["default"].createElement("div", {
        className: "modal-title"
      }, title), closeButton ? _react["default"].createElement("button", {
        className: "close",
        onClick: onRequestHide
      }, _react["default"].createElement(_hamburger.Close, {
        width: "16px",
        color: _colors.granite.base,
        cropped: true
      })) : null);

      var ModalFooter = footer && _react["default"].createElement("div", {
        className: "modal-footer"
      }, footer);

      var modalNode = _react["default"].createElement("div", {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        className: "modal",
        style: _objectSpread({
          display: 'block',
          paddingLeft: '0px'
        }, wrapperStyle),
        tabIndex: "-1"
      }, _react["default"].createElement("div", {
        className: modalClassName,
        style: _objectSpread({
          zIndex: '1050'
        }, style)
      }, _react["default"].createElement("div", {
        className: modalBodyClassName
      }, ModalHeader, _react["default"].createElement("div", {
        className: "modal-body"
      }, this.props.children), ModalFooter)), _react["default"].createElement("div", {
        className: "modal-backdrop fade in",
        onClick: closeOnOutsideClick ? onRequestHide : null
      }));

      return _reactDom["default"].createPortal(modalNode, document.body);
    }
  }]);
  return Modal;
}(_react["default"].Component);

exports["default"] = Modal;
var modalDefaultProps = {
  closeOnOutsideClick: false
};
exports.modalDefaultProps = modalDefaultProps;
var modalPropTypes = {
  title: _propTypes["default"].node,
  className: _propTypes["default"].string,
  style: _reactStyleProptype["default"],
  wrapperStyle: _reactStyleProptype["default"],
  footer: _propTypes["default"].node,
  onRequestHide: _propTypes["default"].func,
  closeOnOutsideClick: _propTypes["default"].bool,
  closeButton: _propTypes["default"].bool,
  bsSize: _propTypes["default"].oneOf(['sm', 'lg']),
  bsStyle: _propTypes["default"].oneOf(['warning', 'error', 'danger', 'success', 'info']),
  children: _propTypes["default"].node
};
exports.modalPropTypes = modalPropTypes;
Modal.defaultProps = modalDefaultProps;
Modal.propTypes = modalPropTypes;